/**
 * Main CXB categories (order 1–15). Investment, Wanted and Bonuses are pinned
 * to the top of every category list via negative order (-3, -2, -1).
 */
export const mainCategories = [
  {
    id: 'investment',
    name: 'Investment',
    icon: 'money',
    subcategories: ['Manufactury', 'Trade', 'Services', 'Other'],
    order: -3,
  },
  { id: 'wanted', name: 'Wanted', icon: 'home', subcategories: [], order: -2 },
  {
    id: 'bonuses',
    name: 'Bonuses',
    icon: 'gift',
    subcategories: [],
    order: -1,
  },
  { id: 'cars', name: 'Cars', icon: 'car', subcategories: [], order: 1 },
  {
    id: 'bikes',
    name: 'Bikes',
    icon: 'motorcycle',
    subcategories: ['Motorcycles', 'Scooters', 'Bicycles', 'Spare Parts'],
    order: 202,
  },
  {
    id: 'properties',
    name: 'Properties',
    icon: 'house',
    subcategories: [
      'For Sale: Houses & Apartments',
      'For Rent: Houses & Apartments',
      'Lands & Plots',
      'New Projects',
      'For Rent: Shops & Offices',
      'For Sale: Shops & Offices',
      'PG & Guest Houses',
    ],
    order: 3,
  },
  {
    id: 'electronics-appliances',
    name: 'Electronics & Appliances',
    icon: 'electronics',
    subcategories: [
      'TVs, Video - Audio',
      'Kitchen & Other Appliances',
      'Computers & Laptops',
      'Cameras & Lenses',
      'Games & Entertainment',
      'Fridges',
      'Computer Accessories',
      'ACs',
      'Washing Machines',
    ],
    order: 4,
  },
  {
    id: 'mobiles',
    name: 'Mobiles',
    icon: 'mobile',
    subcategories: ['Mobile Phones', 'Accessories', 'Tablets'],
    order: 205,
  },
  {
    id: 'commercial-vehicles-spares',
    name: 'Commercial Vehicles & Spares',
    icon: 'truck',
    subcategories: ['Commercial & Other Vehicles', 'Spare Parts'],
    order: 6,
  },
  {
    id: 'jobs',
    name: 'Jobs',
    icon: 'jobs',
    subcategories: [
      'Data entry & Back office',
      'Sales & Marketing',
      'BPO & Telecaller',
      'Driver',
      'Office Assistant',
      'Teacher',
      'Cook',
      'IT Engineer & Developer',
      'Hotel & Travel Executive',
      'Other Jobs',
    ],
    order: 207,
  },
  {
    id: 'furniture',
    name: 'Furniture',
    icon: 'house',
    subcategories: [
      'Sofa & Dining',
      'Beds & Wardrobes',
      'Home Decor & Garden',
      'Kids Furniture',
      'Other Household Items',
    ],
    order: 8,
  },
  {
    id: 'fashion',
    name: 'Fashion',
    icon: 'house',
    subcategories: ['Men', 'Women', 'Kids'],
    order: 9,
  },
  {
    id: 'pets',
    name: 'Pets',
    icon: 'house',
    subcategories: [
      'Dogs',
      'Fishes & Aquarium',
      'Pet Food & Accessories',
      'Other Pets',
    ],
    order: 10,
  },
  {
    id: 'books-sports-hobbies',
    name: 'Books, Sports & Hobbies',
    icon: 'house',
    subcategories: [
      'Books',
      'Gym & Fitness',
      'Musical Instruments',
      'Sports Equipment',
      'Other Hobbies',
    ],
    order: 11,
  },
  {
    id: 'services',
    name: 'Services',
    icon: 'truck',
    subcategories: [
      'Education & Classes',
      'Tutoring & Lessons',
      'Language Courses',
      'Music & Art Classes',
      'Professional Training',
      'Tours & Travel',
      'Transport & Moving',
      'Cleaning Services',
      'Home Cleaning',
      'Electronics Repair & Services',
      'Computer & Phone Repair',
      'Appliance Repair',
      'Health & Beauty',
      'Hair & Salon',
      'Spa & Massage',
      'Fitness & Personal Training',
      'Home Renovation & Repair',
      'Plumbing',
      'Electrical',
      'Painting & Decorating',
      'Carpentry',
      'Gardening & Landscaping',
      'Legal & Financial Services',
      'Accounting & Taxes',
      'Photography & Video',
      'Event Services',
      'Catering',
      'Automotive Services',
      'Pet Services',
      'IT & Web Services',
      'Other Services',
    ],
    order: 12,
  },
  {
    id: 'kids',
    name: 'Kids',
    icon: 'house',
    subcategories: [
      'Toys & Games',
      'Baby Clothing',
      'Strollers & Carriers',
      'School Supplies',
      'Kids Accessories',
    ],
    order: 13,
  },
  {
    id: 'music-instruments',
    name: 'Music & Instruments',
    icon: 'house',
    subcategories: [
      'Guitars',
      'Keyboards & Pianos',
      'Drums & Percussion',
      'Wind Instruments',
      'DJ & Studio Equipment',
      'Other Instruments',
    ],
    order: 214,
  },

  {
    id: 'tools-machinery',
    name: 'Tools & Machinery',
    icon: 'truck',
    subcategories: [
      'Power Tools',
      'Hand Tools',
      'Industrial Machinery',
      'Garden Equipment',
      'Warehouse Equipment',
      'Other Tools',
    ],
    order: 15,
  },

  {
    id: 'industrial',
    name: 'Industrial',
    icon: 'wall',
    subcategories: [
      'Construction and Construction materials',
      'WSS',
      'Farming and Farming materials',
      'Other Industrial',
    ],
    order: 16,
  },
  {
    id: 'art',
    name: 'Art',
    icon: 'ring',
    subcategories: ['Paintings', 'Books', 'Other art'],
    order: 217,
  },
];
